<app-modal-shell [showFooter]="true"
  [dismissLabel]="'general.cancel' | translate"
  (dismiss)="dismiss()">
  <div modalTitle>
    <h2>{{ 'timesheet.title' | translate }}</h2>
  </div>

  <form class="timesheet-dialog"
    id="new-timesheet-form"
    [formGroup]="formGroup"
    (ngSubmit)="onSave()">
    <section class="timesheet-dialog__panel">
      @if (!preUser) {
        @if (users$ | async; as users) {
          <label class="timesheet-dialog__field">
            <app-select-user-picker [labelKey]="'timesheet.user'"
              [items]="users"
              [selectedUsers]="formGroup.get('user').value ?
              [{ guid: formGroup.get('user').value, displayName: formGroup.get('username').value }] : []"
              (selectedChange)="onUserByGuid($event.guid, users)"></app-select-user-picker>
          </label>
        }
      }

      <section class="timesheet-dialog__type-picker">
        <span>{{ 'timesheet.select' | translate }}</span>
        <div class="timesheet-dialog__type-actions">
          <button type="button"
            class="timesheet-dialog__type-button"
            [class.timesheet-dialog__type-button--active]="entryTypeValue() === 'absence'"
            (click)="selectEntryType('absence')">
            {{ 'timesheet.absence' | translate }}
          </button>
          <button type="button"
            class="timesheet-dialog__type-button"
            [class.timesheet-dialog__type-button--active]="entryTypeValue() === 'work'"
            (click)="selectEntryType('work')">
            {{ 'timesheet.own' | translate }}
          </button>
        </div>
      </section>

      @if (entryTypeValue() === 'absence') {
        <label class="timesheet-dialog__field">
          <span>{{ 'timesheet.absence' | translate }}</span>
          <app-select-popover formControlName="absence">
            <ion-select-option [value]="null"
              disabled>{{ 'timesheet.absence' | translate }}</ion-select-option>
            @for (item of getAbsenceOptions(); track item.key) {
              <ion-select-option [value]="item.key">{{ item.name }}</ion-select-option>
            }
          </app-select-popover>
        </label>

        <div class="timesheet-dialog__date-row">
          <label class="timesheet-dialog__field">
            <span>{{ 'timesheet.start' | translate }}</span>
            <app-select-day [name]="'timesheet.start'"
              [type]="'datetime-local'"
              formControlName="dateIn"></app-select-day>
          </label>
          <label class="timesheet-dialog__field">
            <span>{{ 'timesheet.end' | translate }}</span>
            <app-select-day [name]="'timesheet.end'"
              [type]="'datetime-local'"
              formControlName="dateOut"></app-select-day>
          </label>
        </div>
      }

      @if (entryTypeValue() === 'work') {
        @if (site() == null || canChangeSite()) {
          @if (sites$ | async; as sites) {
            <label class="timesheet-dialog__field">
              <app-select-site-picker [labelKey]="'report.selectSite'"
                [items]="sites"
                [selectedSite]="selectedSiteForPicker()"
                (selectedChange)="onSiteSelected($event)"></app-select-site-picker>
            </label>
          }
        } @else {
          <label class="timesheet-dialog__field">
            <span>{{ 'report.selectSite' | translate }}</span>
            <input type="text"
              [value]="site().name"
              readonly />
          </label>
        }

        @if (formGroup.get('site').value) {
          @if (projects$ | async; as projects) {
            <label class="timesheet-dialog__field">
              <app-select-project-picker [labelKey]="'report.selectProject'"
                [items]="projects"
                [selectedProject]="selectedProjectForPicker()"
                (selectedChange)="onProjectSelected($event)"></app-select-project-picker>
            </label>
          }
        }

        @if (formGroup.get('site').value) {
          @if (litteras$ | async; as litteras) {
            @if (litteras.length > 0) {
              <label class="timesheet-dialog__field">
                <span>{{ 'item.littera' | translate }}</span>
                <app-select-popover formControlName="littera">
                  <ion-select-option [value]="null">{{ 'item.littera' | translate }}</ion-select-option>
                  @for (littera of litteras; track littera.code) {
                    <ion-select-option [value]="littera.code">{{ littera.code }}
                      {{ littera.text }}</ion-select-option>
                  }
                </app-select-popover>
              </label>
            }
          }
        }

        <div class="timesheet-dialog__date-row">
          <label class="timesheet-dialog__field">
            <span>{{ 'timesheet.start' | translate }}</span>
            <app-select-day [name]="'timesheet.start'"
              [type]="'datetime-local'"
              formControlName="dateIn"></app-select-day>
          </label>
          <label class="timesheet-dialog__field">
            <span>{{ 'timesheet.end' | translate }}</span>
            <app-select-day [name]="'timesheet.end'"
              [type]="'datetime-local'"
              formControlName="dateOut"></app-select-day>
          </label>
        </div>

        <section class="timesheet-dialog__compensations">
          <h4>{{ 'timesheet.paymentType' | translate }}</h4>

          <label class="timesheet-dialog__comp-row">
            <span>{{ 'timesheet.paymentTypes.kmPay' | translate }}</span>
            <input type="number"
              min="0"
              step="1"
              [value]="formGroup.get('kmPayUnit').value || ''"
              (input)="onMilageAllowanceInput($any($event.target).value)" />
          </label>
          <div class="timesheet-dialog__summary">
            <span>{{ 'timesheet.paymentUnitValue' | translate }} {{ milageAllowance }}€</span>
            <span>{{ 'timesheet.paymentSummary' | translate }} {{ milageAllowanceSummary }}€</span>
          </div>

          <label class="timesheet-dialog__comp-row timesheet-dialog__comp-row--toggle">
            <span>{{ 'timesheet.paymentTypes.fullDay' | translate }}</span>
            <ion-toggle formControlName="fullDay"></ion-toggle>
          </label>

          <label class="timesheet-dialog__comp-row timesheet-dialog__comp-row--toggle">
            <span>{{ 'timesheet.paymentTypes.partDay' | translate }}</span>
            <ion-toggle formControlName="partDay"></ion-toggle>
          </label>
        </section>
      }

    </section>

    <div modalFooter
      class="timesheet-dialog__actions">
      <button class="timesheet-dialog__button timesheet-dialog__button--secondary"
        type="button"
        (click)="dismiss()">
        {{ 'general.cancel' | translate }}
      </button>
      <button class="timesheet-dialog__button timesheet-dialog__button--primary"
        type="submit"
        form="new-timesheet-form"
        [disabled]="!formGroup.valid">
        {{ 'general.save' | translate }}
      </button>
    </div>
  </form>

</app-modal-shell>
